import styled from 'styled-components';
import Constraint from 'js/components/Constraint';
import { verticalPadding, lineHeight } from 'js/components/common/Button/style';

export default styled(Constraint)`
  top: ${verticalPadding + lineHeight / 2}rem;
`;
